import { CampoDeSelecao, type OpcaoDeSelecao } from "@base/ui";
import { Search } from "lucide-react";
import type { FiltroDaConta } from "../lista/filtro-da-conta";

const SITUACOES: readonly OpcaoDeSelecao[] = [
  { valor: "ativo", rotulo: "Ativo" },
  { valor: "convite", rotulo: "Convite pendente" },
  { valor: "desativado", rotulo: "Desativado" },
];

/**
 * Busca por nome/e-mail e filtros de papel e situacao, acima das listas de
 * Usuarios e Acessos.
 */
export function BarraDeFiltrosDaLista({
  valor,
  aoMudar,
  papeis,
}: {
  readonly valor: FiltroDaConta;
  readonly aoMudar: (valor: FiltroDaConta) => void;
  readonly papeis: readonly OpcaoDeSelecao[];
}) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
      <label className="flex h-11 min-w-0 flex-1 items-center gap-2 rounded-lg border border-input bg-card px-3.5 shadow-sm">
        <Search className="size-4 shrink-0 text-muted-foreground" aria-hidden="true" />
        <input
          value={valor.busca}
          onChange={(evento) => aoMudar({ ...valor, busca: evento.target.value })}
          placeholder="Buscar por nome ou e-mail"
          aria-label="Buscar por nome ou e-mail"
          className="w-full bg-transparent text-sm outline-none placeholder:text-muted-foreground"
        />
      </label>
      <CampoDeSelecao
        className="sm:w-48"
        rotulo="Papel"
        textoVazio="Todos"
        opcoes={papeis}
        value={valor.papel}
        onChange={(evento) => aoMudar({ ...valor, papel: evento.target.value })}
      />
      <CampoDeSelecao
        className="sm:w-52"
        rotulo="Situação"
        textoVazio="Todas"
        opcoes={SITUACOES}
        value={valor.situacao}
        onChange={(evento) => aoMudar({ ...valor, situacao: evento.target.value })}
      />
    </div>
  );
}
